import React, { useState, useEffect } from "react";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import TocIcon from "@material-ui/icons/Toc";
import DehazeIcon from "@material-ui/icons/Dehaze";
import NotificationsIcon from "@material-ui/icons/Notifications";

import {
  Navbar,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

import { Link } from "react-router-dom";
import { connect } from "react-redux";
import translate from "../../i18n/translate";
import Switch from "@material-ui/core/Switch";
import { DarckModeAction } from "../../redux/actions/DarckModeAction";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/styles";

import "./style.css";

const stylesFn = () => ({});

const NavbarComp = (props) => {
  const { darck } = props;

  const [isOpen, setOpen] = useState(true);
  const [time, setTime] = useState("");

  // 🔔 MODAL FORM
  const [openNotifForm, setOpenNotifForm] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const toggleNotifForm = () => setOpenNotifForm(!openNotifForm);
  const toggle = () => setOpen(!isOpen);

  // ⏰ TIME
  useEffect(() => {
    const interval = setInterval(() => {
      const d = new Date();
      const h = String(d.getHours()).padStart(2, "0");
      const m = String(d.getMinutes()).padStart(2, "0");
      setTime(
        `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${h}:${m}`
      );
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const theme = createMuiTheme({
    overrides: {
      MuiSwitch: {
        switchBase: {
          color: "#0c0f4e",
          "&$checked": { color: "#fff" },
        },
      },
    },
  });

  return (
    <>
      <Navbar
        className="navbar shadow-sm p-2 rounded"
        style={{
          marginTop: "-10px",
          marginBottom: "10px",
          backgroundColor: darck ? "#fff" : "#172431",
          border: darck ? "" : "2px solid #fff",
        }}
        expand="md"
      >
        {/* ☰ MENU */}
        <TocIcon
          onClick={props.toggle}
          style={{ fontSize: 35, color: darck ? "#0c0f4e" : "#fff" }}
        />

        {/* LOGO */}
        <Link id="logo">
          <img
            src={darck ? "/images/24crmlogo2.png" : "/images/bigwhite24crm.png"}
            alt="Logo"
            width="100"
            height="65"
          />
        </Link>

        <NavbarToggler onClick={toggle}>
          <DehazeIcon
            style={{ fontSize: 35, color: darck ? "#0c0f4e" : "#fff" }}
          />
        </NavbarToggler>

        <Collapse isOpen={!isOpen} navbar>
          <Nav className="ml-auto" navbar>
        
            {/* 🔔 NOTIFICATION → FORM */}
            <span style={{ marginTop: "6%", marginRight: "15px" }}>
              <NotificationsIcon
                onClick={toggleNotifForm}
                style={{
                  cursor: "pointer",
                  fontSize: 28,
                  color: darck ? "#0c0f4e" : "#fff",
                }}
              />
            </span>

            {/* 🌙 DARK MODE */}
            <span style={{ marginTop: "6%" }}>
              <ThemeProvider theme={theme}>
                <Switch
                  size="small"
                  checked={!darck}
                  onChange={() => props.DarckModeAction(!darck)}
                />
              </ThemeProvider>
            </span>

            {/* 👤 USER */}
            <span style={{ marginTop: "6%", marginLeft: "10px" }}>
              <AccountCircleIcon
                style={{ color: darck ? "#0c0f4e" : "#fff" }}
              />
              &nbsp;
              <span
                style={{
                  fontWeight: "bold",
                  color: darck ? "#0c0f4e" : "#fff",
                }}
              >
                {props.Auth.username} &nbsp; {time}
              </span>
            </span>

            {/* 🚪 LOGOUT */}
            <NavItem style={{ marginTop: "4%" }}>
              <NavLink tag={Link} to="/logout">
                <i
                  className="fas fa-sign-out-alt"
                  style={{
                    color: darck ? "rgb(216, 95, 16)" : "#fff",
                  }}
                >
                  &nbsp;{translate("Se Déconnecter")}
                </i>
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>

      {/* 🔔 FORM MODAL */}
      <Modal isOpen={openNotifForm} toggle={toggleNotifForm} centered>
        <ModalHeader toggle={toggleNotifForm}>
          Envoyer une notification
        </ModalHeader>

        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Titre</Label>
              <Input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Titre"
              />
            </FormGroup>

            <FormGroup>
              <Label>Message</Label>
              <Input
                type="textarea"
                rows="4"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Message"
              />
            </FormGroup>
          </Form>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={toggleNotifForm}>
            Annuler
          </Button>
          <Button
            color="primary"
            onClick={() => {
              console.log("Titre :", title);
              console.log("Message :", message);
              toggleNotifForm();
            }}
          >
            Envoyer
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

// ================= REDUX =================
const mapStateToProps = (state) => ({
  Auth: state.Auth,
  darck: state.darck.darck,
});

const mapDispatchToProps = (dispatch) => ({
  DarckModeAction: (v) => dispatch(DarckModeAction(v)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(stylesFn)(NavbarComp));




















































// import React, { useState } from "react";
// import AccountCircleIcon from "@material-ui/icons/AccountCircle";
// import TocIcon from "@material-ui/icons/Toc";
// import DehazeIcon from "@material-ui/icons/Dehaze";
// import {
//   Navbar,
//   NavbarToggler,
//   Collapse,
//   Nav,
//   NavItem,
//   NavLink,
// } from "reactstrap";
// import { Link } from "react-router-dom";
// import { connect } from "react-redux";
// import translate from "../../i18n/translate";
// import Switch from "@material-ui/core/Switch";
// import { DarckModeAction } from "../../redux/actions/DarckModeAction";
// import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
// import { withStyles } from "@material-ui/styles";

// import "./style.css";

// const stylesFn = () => ({
//   input: {
//     color: "#fff",
//   },
//   root: {
//     "& label.Mui-focused": {
//       color: "#fff",
//     },
//     "& .MuiInput-underline:after": {
//       borderBottomColor: "#fff",
//     },
//     "& .MuiOutlinedInput-root": {
//       "& fieldset": {
//         borderColor: "#fff",
//       },
//       "&:hover fieldset": {
//         borderColor: "#fff",
//       },
//       "&.Mui-focused fieldset": {
//         borderColor: "#fff",
//       },
//     },
//   },
// });

// const NavbarComp = (props) => {
//   const [isOpen, setOpen] = useState(true);
//   const [time, setTime] = useState();
//   const { darck } = props;
//   const toggle = () => setOpen(!isOpen);

//   setInterval(() => {
//     const date = new Date().getDate(); //Current Date
//     const month = new Date().getMonth() + 1; //Current Month
//     const year = new Date().getFullYear(); //Current Year
//     const hours = new String(new Date().getHours()); //Current Hours
//     var zero1 = "";
//     var zero2 = "";
//     var zero3 = "";
//     if (new String(hours).length === 1) {
//       zero1 = "0";
//     }
//     const min = new String(new Date().getMinutes()); //Current Minutes
//     if (new String(min).length === 1) {
//       zero2 = "0";
//     }
//     const sec = new String(new Date().getSeconds()); //Current Seconds
//     if (new String(sec).length === 1) {
//       zero3 = "0";
//     }

//     const datenow =
//       date + "/" + month + "/" + year + " " + zero1 + hours + ":" + zero2 + min;
//     setTime(datenow);
//   }, 1000);
//   const username = localStorage.getItem("username");
//   const theme = createMuiTheme({
//     overrides: {
//       MuiSwitch: {
//         switchBase: {
//           color: "#0c0f4e",
//           "&$checked": {
//             color: "#fff",
//           },
//         },
//         track: {
//           opacity: 0.2,
//           backgroundColor: "#0c0f4e",
//           "$checked$checked + &": {
//             opacity: 0.7,
//             backgroundColor: "#fff",
//           },
//         },
//       },
//     },
//   });
//   return (
//     <Navbar
//       darck
//       className="navbar shadow-sm p-2 rounded"
//       style={{
//         marginTop: "-10px",
//         marginBottom: "10px",
//         backgroundColor: `${darck ? "#fff" : "#172431"}`,
//         border: `${darck ? "" : "2px solid #fff"}`,
//       }}
//       expand="md"
//     >
//       <TocIcon
//         onClick={props.toggle}
//         style={{ fontSize: "35px", color: `${darck ? "#0c0f4e" : "#fff"}` }}
//       />
//       {/* </Button> */}

//       {darck ? (
//         <Link id="logo">
//           <img
//             src="/images/24crmlogo2.png"
//             alt="Logo"
//             width="100"
//             height="65"
//           />
//         </Link>
//       ) : (
//         <Link id="logo">
//           <img
//             src="/images/bigwhite24crm.png"
//             alt="Logo"
//             width="100"
//             height="65"
//           />
//         </Link>
//       )}

//       <NavbarToggler onClick={toggle}>
//         <DehazeIcon
//           style={{ fontSize: "35px", color: `${darck ? "#0c0f4e" : "#fff"}` }}
//         />
//       </NavbarToggler>

//       <Collapse isOpen={!isOpen} navbar>
//         <Nav className="ml-auto" navbar>
//           <span style={{ marginTop: "6%" }}>
//             <ThemeProvider theme={theme}>
//               <Switch
//                 size="small"
//                 onChange={() => props.DarckModeAction(!darck)}
//                 color="warning"
//                 name="checkedB"
//                 inputProps={{ "aria-label": "warning checkbox" }}
//                 checked={!darck}
//               />
//             </ThemeProvider>
//           </span>
//           <span style={{ marginTop: "6%" }}>
//             <AccountCircleIcon
//               style={{ color: `${darck ? "#0c0f4e" : "#fff"}` }}
//             />{" "}
//             &nbsp;
//             <span
//               style={{
//                 fontWeight: "bold",
//                 color: `${darck ? "#0c0f4e" : "#fff"}`,
//               }}
//             >
//               {props.Auth.username} 
//               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{new String(time)}
//             </span>
//           </span>

//           <NavItem style={{ marginTop: "4%" }}>
//             <NavLink tag={Link} to={"/logout"}>
//               <i
//                 class="fas fa-sign-out-alt"
//                 style={{
//                   color: `${darck ? "rgb(216, 95, 16)" : "#fff"}`,
//                   fontSize: "16px",
//                 }}
//                 //rgb(220, 0, 78)
//               >
//                 {" "}

//                 {translate("Se Déconnecter")}
//               </i>
//             </NavLink>
//           </NavItem>
//         </Nav>
//       </Collapse>
//     </Navbar>
//   );
// };
// function mapDispatchToProps(dispatch) {
//   return {
//     DarckModeAction: (a) => dispatch(DarckModeAction(a)),
//   };
// }

// function mapStateToProps(state) {
//   return {
//     blbrs: state.blbrs,
//     Auth: state.Auth,
//     darck: state.darck.darck,
//   };
// }

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(withStyles(stylesFn)(NavbarComp));
